<div class="container">
  <div class='slider-wrapper'>
    @for (item of slides; track item; let i = $index) {
      <input name='slides' id="slide{{i+1}}" type='radio'>
    }
    <div class="slide-wrapper2">
      <div id="slide-role">
        @for (item of slides; track item; let i = $index) {
          <div class="slide" ngClass="slide{{i+1}}">
            <div class="sliderImg">
              <img src="{{item.imageUrl}}">
            </div>
            <section class="slider-body">
              <h3 class="slider-body-title">{{item.title}}</h3>
              <p class="slider-body-description">{{ item.text }}</p>
              <button type="button" class="regular button"><a (click)="goItemLink(item)" target="_blank">{{item.buttonCTA}}</a></button>
            </section>
          </div>
        }
      </div>
    </div>
    <div class='slider-arrow-nav'>
      @for (item of slides; track item; let i = $index) {
        <label class='nav-arrow prev' for='slide{{i+1}}'
        (click)="startSlider(i+1, true)"></label>
      }
    </div>
    <div class='slider-nav'>
      @for (item of slides; track item; let i = $index) {
        <label class='nav-button' for='slide{{i+1}}'
        (click)="startSlider(i+1, true)">&nbsp;</label>
      }
    </div>
    <div class='slider-arrow-nav'>
      @for (item of slides; track item; let i = $index) {
        <label class='nav-arrow next' for='slide{{i+1}}'
        (click)="startSlider(i+1, true)"></label>
      }
    </div>
  </div>
</div>
